document.addEventListener("DOMContentLoaded", function () {
  const counters = document.querySelectorAll(".spec-number");
  if (!counters.length) return;

  let triggered = false;

  function countUp() {
    counters.forEach(counter => {
      const target = parseFloat(counter.dataset.count);
      const duration = parseInt(counter.dataset.duration) || 1500;
      const suffix = counter.dataset.suffix || "";
      const unitEl = counter.querySelector(".spec-unit");

      const frame = 16; // 約60fps
      const steps = duration / frame;
      const increment = target / steps;

      let current = 0;

      function update() {
        current += increment;
        if (current < target) {
          counter.firstChild.textContent = Math.floor(current);
          unitEl.textContent = suffix;
          requestAnimationFrame(update);
        } else {
          counter.firstChild.textContent = target;
          unitEl.textContent = suffix;
        }
      }

      update();
    });
  }

  function handleScroll() {
    const section = document.querySelector(".countup-spec-section");
    if (!section) return;

    const rect = section.getBoundingClientRect();
    if (!triggered && rect.top < window.innerHeight * 0.85) {
      triggered = true;
      countUp();
    }
  }

  window.addEventListener("scroll", handleScroll);
  handleScroll();
});
